webpackJsonp([144015003635890],{

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    flex-direction: row;\n  '], ['\n    flex-direction: row;\n  ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(4);
	
	var _gatsbyImage = __webpack_require__(21);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _Layout = __webpack_require__(12);
	
	var _colors = __webpack_require__(10);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _media = __webpack_require__(16);
	
	var _media2 = _interopRequireDefault(_media);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; } /* eslint-disable no-undef, react/prop-types */
	
	
	var style = /*#__PURE__*/(0, _reactEmotion.css)('text-align:center;& ul{list-style-type:none;color:', _colors2.default.primary, ';}h1,h2{padding-bottom:0.5em;}');
	
	var tanssijatStyle = /*#__PURE__*/(0, _reactEmotion.css)('text-align:center;& ul{margin-top:1em;list-style-type:none;color:', _colors2.default.primary, ';}');
	
	var flexStyle = /*#__PURE__*/(0, _reactEmotion.css)('margin-bottom:3em;flex-wrap:wrap;justify-content:space-around;');
	
	var tanssijaStyle = /*#__PURE__*/(0, _reactEmotion.css)('margin-top:2em;padding-left:0.5em;padding-right:0.5em;');
	
	var imgStyle = /*#__PURE__*/(0, _reactEmotion.css)('border-radius:5px;margin-bottom:1em;');
	
	var outerImgWrapper = /*#__PURE__*/(0, _reactEmotion.css)('width:8em;margin-left:auto;margin-right:auto;');
	
	var imgRyhmaStyle = /*#__PURE__*/(0, _reactEmotion.css)('width:100%;margin-top:1em;margin-bottom:1em;');
	
	var outerImgRyhmaWrapper = /*#__PURE__*/(0, _reactEmotion.css)('margin-left:auto;margin-right:auto;');
	
	var lastStyle = /*#__PURE__*/(0, _reactEmotion.css)('text-align:center;padding-bottom:10%;p{margin-top:2em;}');
	
	var tanssijatList = /*#__PURE__*/(0, _reactEmotion.css)('text-align:center;padding-top:2em;display:flex;flex-wrap:wrap;flex-direction:column;justify-content:space-around;& ul{list-style-type:none;color:', _colors2.default.primary, ';}', _media2.default.mid(_templateObject), ';');
	
	var Esiintyjat = function Esiintyjat(_ref) {
	  var data = _ref.data;
	  var hygieia = data.hygieia,
	      apteekkari = data.apteekkari,
	      ryhma = data.ryhma,
	      tytti = data.tytti,
	      maija = data.maija,
	      franz = data.franz;
	
	  return _react2.default.createElement(
	    _Layout.Box,
	    null,
	    _react2.default.createElement(
	      _Layout.Box,
	      {
	        className: style,
	        width: [1, 1, 1 / 2],
	        m: ['3.5rem 0 0 0', '3.5rem 0 0 0', '3.5rem auto 0 auto'],
	        px: [3, 3, 0],
	        color: _colors2.default.secondary
	      },
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Rooleissa'
	      ),
	      _react2.default.createElement(
	        _Layout.Flex,
	        { className: flexStyle },
	        _react2.default.createElement(
	          'div',
	          { className: tanssijaStyle },
	          _react2.default.createElement(_gatsbyImage2.default, {
	            className: imgStyle,
	            outerWrapperClassName: outerImgWrapper,
	            alt: 'Owla ja kadonnut walkia, Tytti, Kuvaaja: Mikko Leinonen',
	            sizes: tytti.childImageSharp.sizes
	          }),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Tytti'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Ella Rautamies'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: tanssijaStyle },
	          _react2.default.createElement(_gatsbyImage2.default, {
	            className: imgStyle,
	            outerWrapperClassName: outerImgWrapper,
	            alt: 'Owla ja kadonnut walkia, Franz, Kuvaaja: Mikko Leinonen',
	            sizes: franz.childImageSharp.sizes
	          }),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Franz'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Jyrki Kontkanen'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: tanssijaStyle },
	          _react2.default.createElement(_gatsbyImage2.default, {
	            className: imgStyle,
	            outerWrapperClassName: outerImgWrapper,
	            alt: 'Owla ja kadonnut walkia, Maija, Kuvaaja: Mikko Leinonen',
	            sizes: maija.childImageSharp.sizes
	          }),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Maija'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Anna Myllyl\xE4'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _Layout.Flex,
	        { className: flexStyle },
	        _react2.default.createElement(
	          'div',
	          { className: tanssijaStyle },
	          _react2.default.createElement(_gatsbyImage2.default, {
	            className: imgStyle,
	            outerWrapperClassName: outerImgWrapper,
	            alt: 'Owla ja kadonnut walkia, Apteekkari, Kuvaaja: Inkeri J\xE4ntti',
	            sizes: apteekkari.childImageSharp.sizes
	          }),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Apteekkari'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Elssa Antikainen'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: tanssijaStyle },
	          _react2.default.createElement(_gatsbyImage2.default, {
	            className: imgStyle,
	            outerWrapperClassName: outerImgWrapper,
	            alt: 'Owla ja kadonnut walkia, Hygieia, Kuvaaja: Inkeri J\xE4ntti',
	            sizes: hygieia.childImageSharp.sizes
	          }),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Hygieia'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Anni Koponen'
	          )
	        )
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Toripolliisi'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Kari Sirni\xF6'
	        )
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Hon'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Aarni Korja / Vili Kolanen'
	        )
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Han'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Iina Kolanen / Lotta Luosuj\xE4rvi'
	        )
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Hen'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Maija Anttonen / Heta Honkalampi'
	        )
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'B\xE4ndi'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Erja Mesim\xE4ki'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Lauri Marjakangas'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'div',
	        { className: tanssijatStyle },
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Tanssijat'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Yli 90 hengen ty\xF6ryhm\xE4 on koottu Oulunsuun nuorisoseuran, Oulunsalon nuorisoseuran ja nuorisoseura Vilikkaan kansantanssinharrastajista sek\xE4 Oulun ammattikorkeakoulun tanssinopettajaopiskelijoista.',
	          _react2.default.createElement('br', null),
	          'I\xE4lt\xE4\xE4n esiintyj\xE4t ovat 7\u201377-vuotiaita.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: lastStyle },
	      _react2.default.createElement(_gatsbyImage2.default, {
	        className: imgRyhmaStyle,
	        outerWrapperClassName: outerImgRyhmaWrapper,
	        alt: 'Owla ja kadonnut walkia, Owla Ty\xF6ryhm\xE4, Kuvaaja: Mikko Leinonen',
	        sizes: ryhma.childImageSharp.sizes
	      }),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Jokkainen on laisesa!'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: tanssijatList },
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            'Arkkukangas Marika'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Haapala Meri'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Heikkinen Teemu'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Heinonen Elena'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Heinonen Aino'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Iljana Anni'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Isoahde Oona'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Jolula Kati'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Jussila Kirsi'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Juvani Raija'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Jylh\xE4 Eetu'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Jylh\xE4 Helka'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Kaikkonen Oona'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Kaikkonen Anu'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Kakko Saila'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Kallen-Autio Heli'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Kallen-Autio Matti'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Kangas Noora'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Kauppi Hilla'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Kauppi Elina'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Kauppi Ari'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Kemppainen Eeva'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Kirppu Anni'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Kohtala Antti'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Koskela Tarja'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Koukkari Reijo'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Krankkala Nea'
	          )
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            'Kunnas Miikku'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Laitinen Emma'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Laukka Jouko'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Lepola Pirkka'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Lukkari Riikka'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Luomajoki Juuso'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Lyly-Yrj\xE4n\xE4inen Maija'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Lyttinen Amanda'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'M\xE4\xE4tt\xE4 Leena'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'M\xE4\xE4tt\xE4 Kalevi'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Malinen Inka'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Malinen Joona'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Malinen Pinja'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Manninen Peppiina'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Mantila Aino'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Martikainen Eino'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Myllyl\xE4 Hannu'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Myllyl\xE4 Maija'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Niva Terhi'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Ollanketo Saana'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Ollanketo Sinna'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'P\xE4\xE4talo Marianne'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Pakkanen P\xE4ivi'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Per\xE4l\xE4 Anna-Emilia'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Per\xE4l\xE4 Veetu'
	          )
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            'Per\xE4l\xE4 Ella'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Per\xE4l\xE4 Henna'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Pietik\xE4inen Kaarina'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Raetsaari Helka'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Raipoaho Raimo'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Rankinen Sini-Pilvi'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Rantap\xE4\xE4 Eila'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Rantap\xE4\xE4 Matti'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Rasila Seija'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Romppainen Roope'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Ronkainen Aino'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'S\xE4\xE4skilahti Santeri'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Salmi Anna'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Salonen Timo'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Savuoja Sini'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Savuoja Niko'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Sepp\xE4l\xE4 Marja\u2013Liisa'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Sepp\xE4nen Laura'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Sirni\xF6 Ailakki'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Suoniemi Siiri'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Suronen Minna'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Tarumaa Riikka'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Tervaskanto Eero'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Tikka Jarkko'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Timonen Sofia'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Valkama Anita'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Veijalainen Susanna'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'small',
	          null,
	          'Kuvat:',
	          _react2.default.createElement('br', null),
	          'Tytti, Franz, Maija, Ryhm\xE4kuva: Mikko Leinonen',
	          _react2.default.createElement('br', null),
	          'Apteekkari, Hygieia: Inkeri J\xE4ntti'
	        )
	      )
	    )
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = Esiintyjat;

/***/ }),

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactEmotion = __webpack_require__(4);
	
	var sizes = {
	  large: 1024,
	  mid: 832,
	  small: 640
	};
	
	// Iterate through the sizes and create a media template
	var media = Object.keys(sizes).reduce(function (acc, label) {
	  acc[label] = function () {
	    return (/*#__PURE__*/(0, _reactEmotion.css)('@media (min-width:', sizes[label] / 16, 'em){', /*#__PURE__*/_reactEmotion.css.apply(undefined, arguments), ';}')
	    );
	  };
	
	  return acc;
	}, {});
	
	exports.default = media;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-esiintyjat-js-00a1a5b9d0430feaf3f0.js